import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ExternalLink } from "lucide-react";

/**
 * Renders the structured citations returned by the Phase 1f ask
 * endpoint. Fields are server-owned + learner-safe (see
 * ask_router._validate_citations). Zero HTML injection risk — every
 * field is rendered as React text.
 */
export default function CitationRefs({ citations }) {
  if (!citations || citations.length === 0) return null;
  return (
    <ol
      data-testid="ask-citation-list"
      className="mt-3 space-y-2 text-xs text-v2-text-muted list-decimal list-inside"
    >
      {citations.map((c, idx) => (
        <li key={c.citation_id} data-testid={`ask-citation-${idx + 1}`} className="leading-snug">
          <span className="text-v2-text font-medium">{c.source_title}</span>
          <span className="text-v2-text-muted"> · position {c.chunk_position + 1}/{c.chunk_total}</span>
          {c.authorized_academy_url && (
            <Link
              to={c.authorized_academy_url}
              data-testid={`ask-citation-link-${idx + 1}`}
              className="ml-2 inline-flex items-center gap-1 text-[#A78BFA] hover:underline"
            >
              <ExternalLink className="w-3 h-3" /> open
            </Link>
          )}
          {c.quote_excerpt && (
            <blockquote className="mt-1 pl-3 border-l border-v2-border text-v2-text-muted">
              {c.quote_excerpt}
            </blockquote>
          )}
        </li>
      ))}
    </ol>
  );
}
